export default "__VITE_ASSET__u738Pf3P__"